import type { EnumBusinessState, EnumProcessState } from '@Model';
import {
    getBadgeVariantByBusinessState,
    getEnumBusinessStateLabel,
    getBadgeVariantByProcessState,
    getEnumProcessStateLabel,
} from '@Model';
import { type ComponentProps, useMemo } from 'react';
import { Badge } from '@synqo/frontend-component-library';

export interface BuildBadges {
    business_state?: EnumBusinessState;
    process_state?: EnumProcessState;
    number?: string;
}

export function useBadges(object?: BuildBadges) {
    const { number, business_state, process_state } = object ?? {};

    const badges: ComponentProps<typeof Badge>[] = useMemo(() => {
        const badges: ComponentProps<typeof Badge>[] = [];
        if (number !== undefined && number.length > 0) {
            badges.push({
                children: 'Nr. ' + number,
                variant: 'primary',
            });
        }
        if (business_state !== undefined) {
            badges.push({
                children: getEnumBusinessStateLabel(business_state),
                variant: getBadgeVariantByBusinessState(business_state),
            });
        }
        if (process_state !== undefined) {
            badges.push({
                children: getEnumProcessStateLabel(process_state),
                variant: getBadgeVariantByProcessState(process_state),
            });
        }

        return badges;
    }, [business_state, process_state, number]);

    return badges;
}
